import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';
import { InfoBanner } from '~/components/ui';
import { shipWeekLabel } from '~/pages/buy-lists/lib/shipWeekLabel';
import {
  RequestForQuoteSummaryPanels,
  type RecipientGroup,
} from '~/pages/buy-lists/sections/RequestForQuoteSummaryPanels';
import type { SummaryProduct } from '~/pages/buy-lists/sections/SummaryProductsPanel';

type RequestForQuoteSummaryStepProps = {
  products: SummaryProduct[];
  recipientGroups: RecipientGroup[];
  expectedShipDate: string;
};

export function RequestForQuoteSummaryStep({
  products,
  recipientGroups,
  expectedShipDate,
}: Readonly<RequestForQuoteSummaryStepProps>) {
  const { t } = useTranslation('inventory');
  const hasTallies = products.some(
    (product) => product.tallyKind !== undefined
  );

  return (
    <div className="flex h-full flex-col gap-3" data-testid="rfq-summary">
      <div
        className="flex items-center gap-2 text-sm text-neut-sec"
        data-testid="rfq-summary-ship-week"
      >
        <Calendar aria-hidden="true" size={16} />
        {shipWeekLabel(t, expectedShipDate)}
      </div>
      {hasTallies && (
        <InfoBanner testId="rfq-summary-tallies-note">
          {t('inventory.buy_list.request_for_quote.tallies_sent_separately')}
        </InfoBanner>
      )}
      <div className="min-h-0 flex-1">
        <RequestForQuoteSummaryPanels
          products={products}
          recipientGroups={recipientGroups}
          productsTestIdPrefix="rfq-summary"
        />
      </div>
    </div>
  );
}
